import { LogoutWrapper, SidebarDetailsFooter, SidebarDetailsFooterWrapper, UserInfo, UserType } from './styles';
import { useUser } from '@/context/userContext';
import { Box } from '@/components/Box/Box';
import { SwitchRoleButton } from '@/bundle/Sidebar/ui/SwitchRoleButton/SwitchRoleButton';
import { getUserRoleLabel } from '@/helpers/userHelpers';

export const SidebarUserDetails = () => {
  const { hasMultipleUserRoles, currentRole, isOpcoRole } = useUser();
  const userRole = getUserRoleLabel(currentRole);

  return (
    <SidebarDetailsFooterWrapper>
      <SidebarDetailsFooter>
        <Box flexDirection='column' rowGap='20px' width='100%'>
          <UserInfo>{userRole && <UserType>{userRole}</UserType>}</UserInfo>
          {hasMultipleUserRoles && <SwitchRoleButton role={currentRole} />}
        </Box>
      </SidebarDetailsFooter>

      <LogoutWrapper hasSupportChat={!isOpcoRole}></LogoutWrapper>
    </SidebarDetailsFooterWrapper>
  );
};
